import Vue from 'vue'

export const getCities = () => Vue.axios.get('locations/cities')
export const getLanguages = () => Vue.axios.get('languages')

export const getOccupations = params => Vue.axios.get('occupations', { params })
export const updateOccupation = (id, data) => Vue.axios.put(`occupations/${id}`, data)
export const reassignOccupation = (id, targetId) => Vue.axios.put(`occupations/${id}/reassign`, { targetId })
export const deleteOccupation = id => Vue.axios.delete(`occupations/${id}`)

export const getSkills = params => Vue.axios.get('skills', { params })
export const getWorklocations = () => Vue.axios.get('worklocations')



// WEBPACK FOOTER //
// ./src/services/resources.js